import styled from 'styled-components';
import {Card} from "antd";

export const CardStyled = styled(Card)`
    border-bottom: 1px solid #d9d9d9;
    
    .ant-card-head {
        padding: 0 16px;
    }
    
    .ant-card-body {
        padding: 0 0 24px 0;
        border-top: 1px solid #d9d9d9;
    }
    
    table {
        th, td {
            padding-left: 16px!important;
            padding-right: 16px!important;
        }
    }
    
    .ant-list-item {
        display: block;
    }
    
    .ant-upload-hint {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
    }
    
    .ant-upload-text {
        margin: 0 0 4px;
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
    }
    
    .form-block-wrapper {
        padding: 20px 20px 0 20px;
    }
    
    .view-block-wrapper {
        padding: 16px 16px 0 16px;
    }
`

export const ViewCardStyled = styled(CardStyled)`
    .ant-card-body {
        padding-bottom: 0;

        .view-block-wrapper {
            padding: 0;
        }
    }
    .ant-descriptions.ant-descriptions-bordered {
        .ant-descriptions-view {
            border: none;
        }
        
        .ant-descriptions-row {
            &:hover {
                background-color: rgba(5, 5, 5, 0.02);
            }

            .ant-descriptions-item-label {
                background-color: transparent;
                border-inline-end: none;
            }

            .ant-descriptions-item-content {
                text-align: right;
            }
        }
    }

    .ant-btn-link {
        padding: 0;
    }
`